import * as fromModels from '@shared/models';
import {UserActions, UserActionTypes} from '@store/actions/user.actions';

export interface UserState {
  loggedinUserAndRoleInfo: fromModels.UserAndRoleInfo;
}

export const initialState: UserState = {
  loggedinUserAndRoleInfo: null
};

export function reducer(state = initialState, action: UserActions): UserState {
  switch (action.type) {
    case UserActionTypes.GetUserSuccess:
    case UserActionTypes.GetUserOnlySuccess:
      return {
        ...state,
        loggedinUserAndRoleInfo: action.payload
      };
    default:
      return state;
  }
}

export const getLoggedinUserAndRoleInfo = (state: UserState) =>
  state.loggedinUserAndRoleInfo;
